import { useEffect, useState } from "react";
import { Card, CardHeader, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
import request from "graphql-request";
import PageLoading from "../../../components/Loading/PageLoading";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialButton from "../../../components/MaterialButton";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { allCompanyDetails } from "./compenyData";
import _ from "lodash";
import URL from "../../../pages/Utils/url";
import BASEURL from "../../../pages/Utils/Baseurl";
import RoleAccess from "../../function/RoleAccess";

const CompenyMaster = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchdata();
  }, []);

  const CompenyListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Company Name",
        field: "companyName",
        name: "companyName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Address",
        field: "address",
        name: "address",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Company Logo",
        field: "companyLogo",
        name: "companyLogo",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created By",
        field: "employeeName",
        name: "employeeName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      companyName: _.capitalize(v?.companyName),
      address: _.capitalize(v?.address),
      companyLogo: v?.companyLogo ? (
        <img src={v?.companyLogo} alt="logo" width={50} height={30} />
      ) : (
        <span style={{ fontSize: "12px" }}>No Image</span>
      ),
      employeeName: v?.user?.employeeName,

      Action: (
        <div
          style={{
            display: "flex",

            marginTop: "6px",
            alignItems: "center",
          }}
        >
          <RoleAccess modelName="Company Screen" component="ViewCompany">
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/master/company-master/view-company-master`, {
                  state: { type: "view", data: v },
                })
              }
            />
          </RoleAccess>
          <RoleAccess modelName="Company Screen" component="UpdateCompany">
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/master/company-master/edit-company-master`, {
                  state: { type: "edit", data: v },
                })
              }
            />
          </RoleAccess>
          {/*
            <DeleteIcon
             fontSize='small'
                  className="actionIcon"
              onClick={() => handleDelte(v?.id)}
            /> */}
        </div>
      ),
    })),
  };

  const fetchdata = () => {
    setIsLoading(true);
    request(BASEURL, allCompanyDetails)
      .then((res) => {
        const success = res?.allCompanyDetails?.success;
        const message = res?.allCompanyDetails?.message;
        if (success) {
          const newdata = res?.allCompanyDetails?.companyDetails?.map(
            (val) => ({
              ...val,
              companyLogo: val?.companyLogo
                ? `${URL}media/${val?.companyLogo}`
                : null,
            })
          );
          setData(newdata);
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,
            showConfirmButton: true,
          });
          setData([]);
        }
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Company Master List
                </MaterialTypography>
              </Stack>
              <RoleAccess modelName="Company Screen" component="CreateCompany">
                {data.length <= 0 && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      navigate("/master/company-master/add-company-master", {
                        state: { type: "add" },
                      })
                    }
                  >
                    Company Master
                  </MaterialButton>
                )}
              </RoleAccess>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={CompenyListTable?.rows}
            columns={CompenyListTable?.columns}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Company Master found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any Company details. Click on the "Add
                    Company Master" button to start adding Company details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default CompenyMaster;
